import { lazy } from 'react';

const CustomInstallacioTelegestio = lazy(() => import('./CustomInstallacioTelegestio'));

export default CustomInstallacioTelegestio;
